import BalanceFonctionnementPanel from '../../classes/panels/BalanceFonctionnementPanel';
import BalanceInvestissementPanel from '../../classes/panels/BalanceInvestissementPanel';
import ChargePersonnelPanel from '../../classes/panels/ChargePersonnelPanel';
import EpargneBrutePanel from '../../classes/panels/EpargneBrutePanel';
import EpargneNettePanel from '../../classes/panels/EpargneNettePanel';
import TypeBudget from './typeBudget';

// TODO: Remettre en constante PANEL_LIST quand correction back fait
const getPanelList = (typeBudget: TypeBudget) => [
	new BalanceFonctionnementPanel(),
	new BalanceInvestissementPanel(),
	...([TypeBudget.BUDGET_PRIMITIF, TypeBudget.COMPTE_ADMINISTRATIF].includes(
		typeBudget,
	)
		? [new ChargePersonnelPanel()]
		: []),
	...([TypeBudget.BUDGET_PRIMITIF, TypeBudget.COMPTE_ADMINISTRATIF].includes(
		typeBudget,
	)
		? [new EpargneBrutePanel()]
		: []),
	...([TypeBudget.BUDGET_PRIMITIF, TypeBudget.COMPTE_ADMINISTRATIF].includes(
		typeBudget,
	)
		? [new EpargneNettePanel()]
		: []),
];

export default getPanelList;
